import { Capacitor } from '@capacitor/core';

/** True inside the iOS / Android Capacitor app, false on the web version (padelmvp.co.uk). */
export const isNativeApp = (() => {
  try {
    return !!Capacitor.isNativePlatform?.();
  } catch (_) {
    return false;
  }
})();
